export default {
  read(itemName) {
    return localStorage.getItem(itemName);
  },
  write(itemName, value) {
    return localStorage.setItem(itemName, value);
  },
  readJSON(itemName) {
    const jsonString = this.read(itemName);
    return jsonString && JSON.parse(jsonString);
  },
  writeJSON(itemName, value) {
    return this.write(itemName, JSON.stringify(value));
  },
};
